'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Properties = require('../Properties.js');

var _Properties2 = _interopRequireDefault(_Properties);

var _ChargeV = require('./ChargeV2.js');

var _ChargeV2 = _interopRequireDefault(_ChargeV);

var _ChargeV2MenuFilter = require('./ChargeV2.MenuFilter.js');

var _ChargeV2MenuFilter2 = _interopRequireDefault(_ChargeV2MenuFilter);

var _Condition = require('./Condition.js');

var _Condition2 = _interopRequireDefault(_Condition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var self = {};

self.isMenuEmpty = function (menu) {
    if (!menu) return true;
    return _lodash2.default.isEmpty(menu.categories);
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

self.createCloneMenuRequest = function (params) {
    var destRestaurantId = params.destRestaurantId,
        sourceMenu = params.sourceMenu,
        locale = params.locale,
        sourceLocale = params.sourceLocale,
        copyCharges = params.copyCharges,
        genId = params.genId;

    // ---------------- Helper functions -----------------------

    // Recursive function to make sure the cloned menu has all the locales
    // needed. This is to fix a bug where the base menu is en_US although
    // the locale of the organization is not en_US

    var fixLocale = function fixLocale(obj) {
        if (_lodash2.default.isArray(obj)) {
            _lodash2.default.each(obj, function (value) {
                return fixLocale(value);
            });
        } else if (_lodash2.default.isObject(obj)) {
            if (obj[sourceLocale] && !obj[locale]) {
                obj[locale] = obj[sourceLocale];
                delete obj[sourceLocale];
            }
            _lodash2.default.each(obj, function (value) {
                return fixLocale(value);
            });
        };
    };

    var traverse = function traverse(obj, func) {
        if (_lodash2.default.isArray(obj)) {
            return _lodash2.default.map(obj, function (value) {
                return traverse(value, func);
            });
        } else if (_lodash2.default.isObject(obj)) {
            var keys = traverse(_lodash2.default.keys(obj), func);
            var values = traverse(_lodash2.default.values(obj), func);
            return _lodash2.default.zipObject(keys, values);
        } else {
            return func(obj);
        }
    };

    // ---------------- Helper functions -----------------------

    // Step 1: Deep clone source menu and 'null' the tags, modified and charges
    var clonedMenu = JSON.parse((0, _stringify2.default)(sourceMenu));
    clonedMenu.tags = null;
    clonedMenu.modified = null;
    clonedMenu.charges = [];
    clonedMenu.chargesV2 = copyCharges ? clonedMenu.chargesV2 : [];

    // Step 2 : Fix the ids to new ones
    var ids = _lodash2.default.union(_lodash2.default.map(clonedMenu.items, 'id'), _lodash2.default.map(clonedMenu.chargesV2, 'id'));
    var newIdsMap = _lodash2.default.zipObject(ids, _lodash2.default.map(ids, function (id) {
        return genId(id);
    }));
    clonedMenu = traverse(clonedMenu, function (id) {
        return newIdsMap[id] || id;
    });

    // Step 3 : Fix locale
    fixLocale(clonedMenu);

    // Make sure everything has a condition and a display condition
    _lodash2.default.each(clonedMenu.items, function (i) {
        if (i.condition && !_lodash2.default.isEqual(i.condition, { type: 'true' })) {
            i.condition = _Condition2.default.complicateCondition(_Condition2.default.simplifyCondition(i.condition));
        } else {
            i.condition = i.condition || { type: 'true' };
        }

        if (i.displayCondition && !_lodash2.default.isEqual(i.displayCondition, { type: 'true' })) {
            i.displayCondition = _Condition2.default.complicateCondition(_Condition2.default.simplifyCondition(i.displayCondition), { deliveryType: true, availability: true });
        } else {
            i.displayCondition = i.displayCondition || { type: 'true' };
        }
    });

    _lodash2.default.each(clonedMenu.sections, function (s) {

        if (s.condition && !_lodash2.default.isEqual(s.condition, { type: 'true' })) {
            s.condition = _Condition2.default.complicateCondition(_Condition2.default.simplifyCondition(s.condition));
        } else {
            s.condition = s.condition || { type: 'true' };
        }

        if (s.displayCondition && !_lodash2.default.isEqual(s.displayCondition, { type: 'true' })) {
            s.displayCondition = _Condition2.default.complicateCondition(_Condition2.default.simplifyCondition(s.displayCondition), { deliveryType: true });
        } else {
            s.displayCondition = s.displayCondition || { type: 'true' };
        }

        _lodash2.default.each(s.children, function (s2) {

            if (s2.condition && !_lodash2.default.isEqual(s2.condition, { type: 'true' })) {
                s2.condition = _Condition2.default.complicateCondition(_Condition2.default.simplifyCondition(s2.condition));
            } else {
                s2.condition = s2.condition || { type: 'true' };
            }

            if (s2.displayCondition && !_lodash2.default.isEqual(s2.displayCondition, { type: 'true' })) {
                s2.displayCondition = _Condition2.default.complicateCondition(_Condition2.default.simplifyCondition(s2.displayCondition), { deliveryType: true });
            } else {
                s2.displayCondition = s2.displayCondition || { type: 'true' };
            }
        });
    });

    return {
        type: 'set_menu',
        organizationId: destRestaurantId,
        menu: clonedMenu
    };
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

self.convertMenuToInternal = function (_ref) {
    var menu = _ref.menu;

    var ret = JSON.parse((0, _stringify2.default)(menu));

    ret.simplifiedCharges = [];

    var discountGroups = {};

    _lodash2.default.each(ret.chargesV2, function (charge) {
        if (_ChargeV2.default.chargeIsTax(charge)) {
            // charge is a tax: simplify and add to ret
            var simpleTax = _ChargeV2.default.simplifyCharge({ charge: charge });
            if (simpleTax) {
                ret.simplifiedCharges.push(simpleTax);
            }
        } else {
            // charge is a discount: simplify and add to one of the discount groups (by groupid)
            var groupId = _Properties2.default.get(charge, 'groupId') || charge.id;
            var simpleCharge = _ChargeV2.default.simplifyCharge({ charge: charge });
            if (simpleCharge) {
                discountGroups[groupId] = discountGroups[groupId] || [];
                discountGroups[groupId].push(simpleCharge);
            }
        }
    });

    _lodash2.default.each(discountGroups, function (group) {
        var simpleCharge = group[0];
        simpleCharge.chargeIds = _lodash2.default.map(group, 'id');
        ret.simplifiedCharges.push(simpleCharge);
    });

    return ret;
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

self.convertInternalMenuToServerMenu = function (_ref2) {
    var menu = _ref2.menu,
        generateUuid = _ref2.generateUuid;


    var ret = _lodash2.default.cloneDeep(menu);

    var recomplicatedCharges = [];

    var taxes = _lodash2.default.filter(ret.simplifiedCharges, { type: 'tax' });
    var discounts = _lodash2.default.filter(ret.simplifiedCharges, function (charge) {
        return charge.type != 'tax' && charge.type != 'tip';
    });
    var tips = _lodash2.default.filter(ret.simplifiedCharges, { type: 'tip' });

    // Get a list of all item IDs. We will remove all items that are taxed, to eventually have all untaxed items
    var untaxedItemIds = _lodash2.default.difference(_lodash2.default.map(menu.items, 'id'), _lodash2.default.flatten(_lodash2.default.map(taxes, 'filters.menuFilter.ids')));

    var taxMap = _lodash2.default.zipObject(_lodash2.default.map(taxes, 'data.percent'), _lodash2.default.map(taxes, function (tax) {
        return {
            itemIds: _lodash2.default.get(tax, 'filters.menuFilter.ids') || [],
            chargeIds: [],
            simpleTax: tax
        };
    }));

    if (!taxMap[0]) {
        taxMap[0] = {
            itemIds: untaxedItemIds,
            chargeIds: []
        };
    } else {
        taxMap[0].itemIds = (taxMap[0].itemIds || []).concat(untaxedItemIds);
    }

    _lodash2.default.each(discounts, function (discount) {
        var menuFilterItemIds = _ChargeV2MenuFilter2.default.menuFilterToIdsFilter({ menuFilter: _lodash2.default.get(discount, 'filters.menuFilter'), menu: menu });
        var discountItemIds = discount.deleted ? [] : menuFilterItemIds.type == 'include' ? menuFilterItemIds.ids : _lodash2.default.map(menu.items, 'id');

        // Workaround for an edge case: if the discount affects no items, then the following loop
        // fails to add a complicated charge. If the discount is new then it will be ignored, and
        // if it's old then it will be overwritten as a disabled discount. This should fix it.
        var forceAddCharge = discountItemIds.length == 0;

        var reusableChargeIds = _lodash2.default.cloneDeep(discount.chargeIds || []);

        _lodash2.default.each(taxMap, function (taxRate, taxAmount) {
            var relevantItemIds = _lodash2.default.intersection(taxRate.itemIds, discountItemIds);

            if (forceAddCharge || relevantItemIds.length > 0) {
                forceAddCharge = false;

                // Get a reusable ID for this charge. If we're out of reusable IDs, generate a new
                // one and add it to the chargeIds of the relevant simplified discount in ret
                var chargeId = function () {
                    var newId = reusableChargeIds.shift() || generateUuid();
                    discount.chargeIds = _lodash2.default.union([], discount.chargeIds, [newId]);
                    return newId;
                }();

                // We generate several copies of what is essentially the same charge;
                // the only differences are the itemIds, and of course the chargeId
                var newCharge = _ChargeV2.default.complicateCharge({
                    charge: (0, _extends3.default)({}, discount, { groupId: discount.id, id: chargeId }),
                    menu: menu,
                    forceItemIds: discount.deleted ? null : relevantItemIds
                });

                if (taxAmount != 0) {
                    taxRate.chargeIds.push(chargeId);
                }

                recomplicatedCharges.push(newCharge);
            }
        });

        // If we have extra chargeIds left in this discount, create empty charges for them
        _lodash2.default.each(reusableChargeIds, function (chargeId) {
            recomplicatedCharges.push(_ChargeV2.default.complicateCharge({ charge: (0, _extends3.default)({}, discount, { id: chargeId, groupId: discount.id, disabled: true }), menu: menu }));
        });
    });

    // Now we can iterate over the taxes in taxMap and create the corresponding tax charge objects
    _lodash2.default.each(taxMap, function (tax) {
        if (tax.simpleTax) {
            var simpleTax = _lodash2.default.set(_lodash2.default.cloneDeep(tax.simpleTax), 'filters.chargeIds', tax.chargeIds);
            recomplicatedCharges.push(_ChargeV2.default.complicateCharge({ charge: simpleTax, menu: menu }));
        }
    });

    // Now we can convert the tip charge as well
    _lodash2.default.each(tips, function (tip) {
        var newCharge = _ChargeV2.default.complicateCharge({ charge: tip, menu: menu });
        recomplicatedCharges.push(newCharge);
    });

    // There might be charges that were not simplified in the first place when we loaded the menu,
    // but we still need to save them
    var leftoverCharges = _lodash2.default.filter(menu.chargesV2, function (charge) {
        return !_lodash2.default.find(recomplicatedCharges, { id: charge.id });
    });
    ret.chargesV2 = recomplicatedCharges.concat(leftoverCharges);

    return ret;
};

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

self.convertVariationsToInternalVariations = function (variations) {
    variations.forEach(function (variation) {
        variation.itemIds = _lodash2.default.compact(_lodash2.default.map(variation.itemIds || [], function (itemId) {

            if (!itemId) return null;
            if (typeof itemId != 'string') itemId = itemId.itemId;

            if (itemId.indexOf(':') === -1) {
                return { itemId: itemId, count: 1 };
            }

            var parts = itemId.split(':');

            return { itemId: parts[0], count: parseInt(parts[1]) }; // TODO: max if count doesn't exist?
        }));

        variation.defaults = _lodash2.default.reduce(variation.defaults || [], function (rc, itemId) {
            var parts = itemId.toString().split(':');
            rc[parts[0]] = parseInt(parts[1]) || 1; // TODO: max if count doesn't exist?
            return rc;
        }, {});

        var prices = {};
        _lodash2.default.each(variation.prices, function (price, itemId) {
            if (itemId.indexOf(':') === -1) {
                prices[itemId] = prices[itemId] || {};
                prices[itemId][1] = price;
            } else {

                var parts = itemId.split(':');
                prices[parts[0]] = prices[parts[0]] || {};
                prices[parts[0]][parseInt(parts[1]) || 'max'] = price;
            }
        });

        variation.prices = prices;
    });

    return variations;
};

self.convertVariationsToExternalVariations = function (variations) {
    _lodash2.default.map(variations, function (variation) {
        variation.itemIds = _lodash2.default.map(variation.itemIds, function (itemId) {
            return itemId.count === 1 ? itemId.itemId : itemId.itemId + ':' + itemId.count;
        });

        var defaults = variation.defaults;
        variation.defaults = [];
        _lodash2.default.each(defaults, function (count, itemId) {
            variation.defaults.push(count === 1 ? itemId : itemId + ':' + count);
        });

        var prices = {};
        _lodash2.default.each(variation.prices || {}, function (pricesMap, itemId) {
            // Currently not supporting more than one price per variation item.
            // Take from old github version when wanting to support more in the
            // future.
            //
            prices[itemId] = (typeof pricesMap === 'undefined' ? 'undefined' : (0, _typeof3.default)(pricesMap)) == 'object' ? pricesMap[1] : pricesMap;
        });

        variation.prices = prices;

        if (_lodash2.default.isEmpty(variation.defaults)) delete variation.defaults;
        if (_lodash2.default.isEmpty(variation.prices)) delete variation.prices;

        return variation;
    });

    return variations;
};

exports.default = self;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/openrest-helpers/Menu.js
// module id = 284
// module chunks = 0